/**
 *
 * @component 用户中心/数据看板/项目状态统计卡片
 *
 **/
import { useHistory } from 'react-router-dom';
import { Empty } from 'antd';
import BaseCard from '@/components/UserCenter/BaseCard';
import ECharts from '&/components/BaseECharts/index';
import { Select } from '&/components/AntdEncapsulation';
import { pieOption } from './constants';
import { getItemData } from '@/api/personCenter/dataBoard';
import './StatusStatistics.scss';

function StatusStatistics(props) {
    const {
        defaultValue,
        baseParams = {},
        managerOpts,
        dayOpts,
        isAdmin = false,
        userId = null,
    } = props;

    const [params, setParams] = useState({
        div: 2,
        managerId: userId,
        days: 30,
    });
    const [isEmpty, setEmpty] = useState(false);
    const [data, setData] = useState([]);

    const paramsRef = useRef();

    const options = {
        ...pieOption,
        color: [
            '#2863FC',
            '#5CC6C7',
            '#FCE94E',
            '#8EECB3',
            '#F4AE3D',
            '#5723E1',
        ],
        series: [
            {
                type: 'pie',
                selectedOffset: 0,
                left: 68,
                radius: ['45%', '70%'],
                avoidLabelOverlap: true,
                label: {
                    position: 'outside',
                    formatter: '{d}%', //百分比。
                    color: 'rgba(0, 0, 0, 0.4)',
                },
                labelLine: {
                    // length: 1,
                    length2: 0,
                },
                data,
                hideOverlap: false,
            },
        ],
    };

    const formatData = list => {
        let count = 0;
        const next = list.map(item => {
            count += +item.number;
            return {
                name: item.name,
                value: item.number,
            };
        });
        setEmpty(count === 0);
        return next;
    };

    const canInit = !params.managerId && params.days === 30;

    useEffect(() => {
        canInit && setData(formatData(defaultValue || []));
    }, [defaultValue]);

    useEffect(() => {
        !canInit && reloadData();
    }, [baseParams.entId]);

    const first = useRef(true);
    useEffect(() => {
        !first.current && reloadData();
        first.current = false;
        paramsRef.current = params;
    }, [params]);

    const onChange = (val, key) => {
        setParams(prev => {
            const next = { ...prev };
            return {
                ...next,
                [key]: val,
            };
        });
    };

    function reloadData() {
        const PARAMS = { ...baseParams, ...params };
        if (!baseParams.entId) {
            delete PARAMS.entId; // 让axios 自带entId
        }
        getItemData(PARAMS).then(({ data: response }) => {
            setData(formatData(response));
        });
    }

    const filterEl = (
        <>
            {managerOpts && (
                <Select
                    onChange={e => onChange(e, 'managerId')}
                    className="manager-select"
                    showSearch
                    filterOption={(input, option) =>
                        (option?.label ?? '')
                            .toLowerCase()
                            .includes(input.toLowerCase())
                    }
                    options={managerOpts}
                    value={params.managerId}></Select>
            )}
            <Select
                value={params.days}
                onChange={e => onChange(e, 'days')}
                options={dayOpts}></Select>
        </>
    );

    const HISTORY = useHistory();
    const targetList = ({ name }) => {
        const urlParam = new URLSearchParams('');
        if (name) {
            let status = 0;
            if (name === '未开始') {
                status = 0;
            } else if (name === '施工中') {
                status = 1;
            } else if (name === '待验收') {
                status = 2;
            } else if (name === '已验收') {
                status = 3;
            } else if (name === '已延期') {
                status = 4;
            }
            urlParam.append('status', status);
        }
        if (!isAdmin) {
            urlParam.append('manager', userId);
        } else if (paramsRef.current.managerId) {
            urlParam.append('manager', paramsRef.current.managerId);
        }
        urlParam.append('days', paramsRef.current.days);
        const path = isAdmin
            ? '/user-center/administrator/status-list?' + urlParam.toString()
            : '/user-center/manager/status-list?' + urlParam.toString();
        HISTORY.push(path);
    };

    return (
        <BaseCard
            className="status-statistics"
            title={intl.get('dataBoard.projectStatusStatistics')}
            headerExtra={filterEl}>
            {isEmpty ? (
                <Empty
                    image={
                        require('&/assets/img/userCenter/emptyydata-object.png')
                            .default
                    }
                    imageStyle={{
                        height: 160,
                    }}
                    description={
                        <div className="hint-message">暂无数据</div>
                    }></Empty>
            ) : (
                <ECharts
                    height="19.75rem"
                    option={options}
                    listeners={[{ key: 'click', handler: targetList }]}
                />
            )}
        </BaseCard>
    );
}

export default StatusStatistics;
